<template>
  <a-card
      style="width:100%;height:100%"
      :tab-list="tabListNoTitle"
      :active-tab-key="noTitleKey"
      @tabChange="key => onTabChange(key)"
    >
    <p v-if="noTitleKey === 'server-log'">
      <ServerLog></ServerLog>
    </p>
    <p v-else-if="noTitleKey === 'getway-log'">
      <GatewayLog></GatewayLog>
    </p>
  </a-card>
</template>

<script>
import ServerLog from "@/views/console/remote-connect-manage/component/ServerLog";
import GatewayLog from "@/views/console/remote-connect-manage/component/GatewayLog";
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
export default {
  name: "LogList",
  components: {GatewayLog, ServerLog},
  data(){
    return {
      noTitleKey: 'server-log',
      tabListNoTitle : [
        {
          key: 'server-log',
          tab: '服务器日志',
        },
        {
          key: 'getway-log',
          tab: '网关日志',
        },
      ]
    }
  },
  methods:{
    onTabChange(key) {
      this.noTitleKey = key;
    }
  }
}
</script>

<style scoped>

</style>